import { apiClient } from "../../../api/client";
import * as ActionType from "./reels.type";
import { setToast } from "../../../util/toast";

// GET REELS
export const getReels = () => async (dispatch) => {
  const res = await apiClient.get("reels/getAllReels");
  if (res.ok) {
    dispatch({ type: ActionType.GET_REELS, payload: res.data?.reels });
  } else {
    console.error(res.message);
  }
};

export const getReportedReel = () => async (dispatch) => {
  const res = await apiClient.get("reels/getReportedReels");
  if (res.ok) {
    dispatch({ type: ActionType.GET_REPORTED_REELS, payload: res.data?.reels });
  } else {
    console.error(res.message);
  }
};

// Delete reels
export const deleteReel = (id) => async (dispatch) => {
  const res = await apiClient.delete(`reels/deleteReel?reelId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DELETE_REELS,
      payload: id,
    });
    setToast("success", "Reel deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const reelInfo = (id) => async (dispatch) => {
  const res = await apiClient.get(`reels/reelsDetail?reelId=${id}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_REEL_INFO,
      payload: res.data?.reel,
    });
  } else {
    console.error(res.message);
  }
};
